import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledInputCount } from './index.style';

export const InputCount = ({
  onBlur,
  onChange,
  error,
  value,
  name,
  placeholder,
  maxChar,
}) => {
  const { t } = useTranslation();
  const errorKey = error?.key;
  const isError = Boolean(errorKey);

  return (
    <StyledInputCount isError={isError}>
      <div className="row-input">
        <div className="input-count">
          <input
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            name={name}
            spellcheck="false"
            placeholder={placeholder}
          />
          <div className="count-text">
            {value?.length}/{maxChar}
          </div>
        </div>
      </div>
      {isError && <div className="msg-error">{t(errorKey, error?.params)}</div>}
    </StyledInputCount>
  );
};
